import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Card, CardBody } from 'reactstrap';
import { auth } from '../../Api';
import { isPrivateAccount, myLocationsPath } from '../../utils/accountType';
import { gettingStartedSteps, showGettingStarted } from '../../utils/gettingStarted';
import './gettingStarted.scss';

// The dashboard's "Getting started" card (utils/gettingStarted.js)
function GettingStarted({ history }) {
	const level = localStorage.getItem('admin_level');
	const [reply, setReply] = useState(null);
	useEffect(() => {
		if (level !== 'c') {
			return undefined;
		}
		let current = true;
		auth.getGettingStarted({ company_id: localStorage.getItem('companyId') })
			.then((res) => { if (current && res.data.code == 200) setReply(res.data); })
			.catch(() => {});
		return () => { current = false; };
	}, [level]);
	if (!reply || !showGettingStarted(level, reply.steps)) {
		return null;
	}
	const steps = gettingStartedSteps(isPrivateAccount(), reply.steps, reply.first_guard_id, myLocationsPath());
	return (
		<Card className="getting-started">
			<CardBody>
				<h4 className="getting-started-title">Getting started</h4>
				<ol className="getting-started-steps">
					{steps.map((step) => (
						<li key={step.key} className={step.done ? 'done' : ''}>
							<span className="getting-started-tick" aria-label={step.done ? 'Done' : 'To do'}>{step.done ? '✓' : ''}</span>
							<span className="getting-started-label">{step.label}</span>
							{!step.done && (step.path
								? <Button size="sm" color="primary" onClick={() => history.push(step.path)}>{step.button}</Button>
								: <span className="text-muted small">{step.waiting}</span>)}
						</li>
					))}
				</ol>
			</CardBody>
		</Card>
	);
}

export default withRouter(GettingStarted);
